export const kfzxRouter = [{
  path: '/kfzx',
  component: () => import('./views/index')
}, {
  path: '/kfzx/intro',
  component: () => import('./views/intro')
}, {
  path: '/kfzx/preapply',
  component: () => import('./views/preapply')
}, {
  path: '/kfzx/apply',
  component: () => import('./views/apply')
}, {
  path: "/kfzx/docs",
  component: () => import('./views/docs')
}, {
  path: "/kfzx/detail",
  component: () => import('./views/detail')
}, {
  path: '/kfzx/list',
  component: () => import('./views/list')
}, {
  path: '/kfzx/info',
  component: () => import('./views/info')
}, {
  path: '/kfzx/chat',
  component: () => import('./views/chat.vue')
}]



// WEBPACK FOOTER //
// ./src/page/kfzx/router.js